import React, { Component, useState } from 'react';
import logo from './logo.svg';
import './App.css';
import './utils/OverrideFuncs'
import DataCenter from './modules/DataCenter';
import MainMenu from './components/MainMenu';
import { ViewConfig } from './conf/Config'
import WebSocketClient from './modules/WebSocketClient';
import Button from './components/control/Button';
import LoginView from './views/LoginView';
import { BrowserRouter, Navigate, Route, Routes, useNavigate, useParams } from 'react-router-dom';
import { Events, JSEvent } from './utils/JSEvent';
import { ToastView } from './components/Toast';
import { BottomPopWindow } from './components/BottomPopWindow';
import AutoLoginView from './views/AutoLoginView';
import FirebaseLoginView from './views/FirebaseLoginView';

//供native程序调用的接口
window.walletBridge = {
  setLoginInfo: (id, key) => {
    if (window.appInst != null) {
      window.appInst.setLoginInfo(id, key);
    }
  },

  setClientInfo: (channel, clientModuleId, customServiceId) => {
    if (window.appInst != null) {
      window.appInst.setClientInfo(channel, clientModuleId, customServiceId);
    }
  },

  setFirebaseLoginToken: (firebaseToken, customServiceId) => {
    if (window.appInst != null) {
      window.appInst.setFirebaseToken(firebaseToken, customServiceId);
    }
  },

  getLoginInfo: () => {
    return {
      id: DataCenter.accountId,
      key: DataCenter.loginKey
    }
  }
}


class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loginId: "None",
      loginKey: "None",
      clientModuleId: "",
      channel: "",
    }
    window.appInst = this;
  }

  componentDidMount() {
    //this.setFirebaseToken("eyJhbGciOiJSUzI1NiIsImtpZCI6ImM2MGI5ZGUwODBmZmFmYmZjMTgzMzllY2Q0NGFjNzdmN2ZhNGU4ZDMiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJodHRwczovL3NlY3VyZXRva2VuLmdvb2dsZS5jb20vbGVzLXdlYjMtcGxhdGZvcm0iLCJhdWQiOiJsZXMtd2ViMy1wbGF0Zm9ybSIsImF1dGhfdGltZSI6MTY5MzE4MjUyNiwidXNlcl9pZCI6IlhSd2hpbHNZUUJUSlFFNGgzV0lpRWNLSGlFTjIiLCJzdWIiOiJYUndoaWxzWVFCVEpRRTRoM1dJaUVjS0hpRU4yIiwiaWF0IjoxNjkzMzU1OTk1LCJleHAiOjE2OTMzNTk1OTUsImVtYWlsIjoidHRrdXJha2lAbGl2ZS5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwiZmlyZWJhc2UiOnsiaWRlbnRpdGllcyI6eyJlbWFpbCI6WyJ0dGt1cmFraUBsaXZlLmNvbSJdfSwic2lnbl9pbl9wcm92aWRlciI6InBhc3N3b3JkIn19.IjL3rXx7gthPyDHyJlrxbHt1ASeQSpXSy3W78lkQ8bxPUIMXTOc0GdLTJKz3Qf9T3cgTQSy-DwX7EEfqc1Y-uVmpdoRNcBhBWvWiXdX_jR6V8MkCmSRF7u-QbYawuOvKtWWHWpFatSWq5mEgvohegLH2zb8tVxNAkjGuhwmfNWuX4jTyUcMTBzGKWPIqKDSAZ8CfAl7TZzsA3LE0gQbV3M-SEK2epCMOJ0ayLo_QVbuTbAIvRomOw1PhtjNHjSz7E2G9yhYhOjDbPJqGykjxnAP2tNaQ2lORSFIP9y0-Q328Fbgft96SoXHFPyiTcIfXsEYsxNgYS5L1M0xdwAXk8Q")
    setTimeout(() => {
      //1秒后，如果没有客户端调用setClientInfo，则直接发送System.Ready事件
      if (this.state.channel == "" && DataCenter.firebaseToken == null) {
        JSEvent.emit(Events.System.Ready, {})
      }
    }, 1000);
  }

  setClientInfo(channel, clientModuleId) {
    this.setState({ channel: channel, clientModuleId: clientModuleId });
    DataCenter.setClientInfo(clientModuleId, channel);
    //发送System.Ready事件
    JSEvent.emit(Events.System.Ready, {})
  }

  setLoginInfo(id, key) {
    this.setState({ loginId: id, loginKey: key });
    DataCenter.setLoginInfo(id, key);
    DataCenter.init();
  }

  setFirebaseToken(firebaseToken, customServiceId) {
    DataCenter.firebaseToken = firebaseToken;
    DataCenter.customServiceId = customServiceId;
    DataCenter.channel = "Firebase";

    //发送System.Ready事件
    JSEvent.emit(Events.System.Ready, {})
  }

  render() {
    // let body = {}
    // if (DataCenter.isLogin()) {
    //   body = <MainView />
    // } else {
    //   body = <LoginView />
    // }

    // return <div className='w-full h-full'>
    //   {body}
    // </div>

    return <AppMain />

  }
}

const AppMain = (props) => {
  return <div className='w-full h-full bg-white'>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainView />} />
        {/* <Route path="/login" element={<LoginView />} /> */}
        <Route path="/login" element={<FirebaseLoginView />} />
        <Route path="/appLogin/:firebaseToken" element={<AutoLoginView />} />
        <Route path="/reg" >
          <Route path="" element={<LoginView toRegView={true} />} />
          <Route path=":refCode" element={<LoginView toRegView={true} />} />
        </Route>
      </Routes>
    </BrowserRouter>
    <BottomPopWindow />
    <ToastView />
  </div>
}


class MainView extends Component {

  constructor(props) {
    super(props);
    this.state = {
      currView: "",
      viewParms: {},
      inputTestId: false,
    }
    //window.setAppInst(this);
  }

  componentDidMount() {
    //setTimeout(() => this.displayIdInput(), 500);
    //this.setLoginInfo(Math.floor(Math.random() * 100) + 1, "asdf", 0xA001);
    //this.setLoginInfo(52, "asdf");
    //this.setLoginInfo(98, "asdf");
  }

  displayIdInput() {
    if (this.state.loginId == "None") {
      console.log("input id...");
      this.setState({
        inputTestId: true
      })
    }
  }


  onItemSelected(itemName, params) {
    const viewParam = this.state.viewParms[itemName];
    if (params == null) {
      params = viewParam
    }
    else {
      this.state.viewParms[itemName] = params;
    };


    this.setState({ currView: itemName, viewParms: this.state.viewParms });
  }

  render() {
    if (!DataCenter.isLogin()) {
      return <Navigate to="/login" />
    }

    const view = ViewConfig[this.state.currView];
    let viewCode = "";
    if (view != null && view.component != null && view.component != "") {
      const ViewDom = view.component;
      const p = this.state.viewParms[this.state.currView];
      viewCode = <ViewDom name={this.state.currView} controller={new view.controller()} {...p} />
    }

    return (
      <div className="flex flex-1 flex-col justify-start h-full w-full overflow-hidden" >
        {/* <div className=" w-px bg-gray-300" /> */}
        <div className='flex w-full bg-white flex-1' >
          {viewCode}
        </div>
        <div>
          <MainMenu onSelected={(itemName, cfg, params) => { this.onItemSelected(itemName, params) }} />
        </div>
        <div>
          {
            this.state.inputTestId ? <TestIdInput onIdSelected={
              id => {
                this.setState({ inputTestId: false });
                this.setLoginInfo(id, "test", 0xa001);
              }
            } /> : ""
          }
        </div>
      </div>
    )
  }
}


const TestIdInput = ({ onIdSelected }) => {
  const [num, setNum] = useState(50);
  return <div className=' absolute left-0 top-0 w-full h-full flex justify-center items-center bg-black opacity-80'>
    <div className=' flex flex-col p-4 w-80 h-40 bg-white rounded-md shadow-2xl'>
      <div className='flex flex-col w-full justify-center items-center'>
        <div>输入测试ID, 范围[50-100]</div>
        <input className=' text-center border-[1px] rounded-md border-black p-1 my-4 w-40' type={"number"}
          value={num} min={50} max={100} onChange={e => {
            let v = e.target.value;
            setNum(v);
          }} onBlur={e => {
            let v = e.target.value;
            if (v < 50) v = 50;
            if (v > 100) v = 100;
            setNum(v);
          }} />
        <Button name="确定" type="primary" onClicked={e => {
          if (onIdSelected) {
            onIdSelected(num);
          }
        }} />
      </div>
    </div>
  </div>
}

export default App;


